// frontend/src/components/games/memory/emojiPool.ts
//
// Hafıza Oyunu için kullanılan emoji havuzu. Kod/programlama ile ilgili
// hiçbir ikon kullanılmaz — yalnızca eğlenceli, çocuk dostu emojiler.

export const FRUIT_EMOJIS = ['🍎', '🍌', '🍇', '🍓', '🍉', '🍒', '🥝', '🍍', '🍑', '🥭'];
export const ANIMAL_EMOJIS = ['🐶', '🐱', '🦊', '🐼', '🦁', '🐸', '🐵', '🐷'];
export const VEHICLE_EMOJIS = ['🚗', '🚕', '🚓', '🚑', '✈️', '🚲', '🚀', '🚂'];
export const OBJECT_EMOJIS = ['🎈', '🎁', '🎮', '💡', '📚', '🎧', '⌚', '🧸', '🎯', '🎨'];

export const EMOJI_POOL: string[] = [
  ...FRUIT_EMOJIS,
  ...ANIMAL_EMOJIS,
  ...VEHICLE_EMOJIS,
  ...OBJECT_EMOJIS,
];

/** Fisher-Yates shuffle — orijinal diziyi bozmadan yeni bir dizi döndürür. */
export function shuffle<T>(items: T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
